export default __webpack_public_path__ + "static/media/pin_blue.eb5c052c.svg";